import instObj from '@/backend/axios-instances'

const resource = "/finishingstep"
const instance = instObj.baseInstance

export default {
  get(stepId, parameters) {
    return instance.get(`${resource}/${stepId}`, { params: parameters });
  },
  put(stepId, data, parameters) {
    return instance.put(`${resource}/${stepId}`, data, { params: parameters });
  },
  delete(stepId) {
    return instance.delete(`${resource}/${stepId}`);
  }
}
